import { css } from 'styled-components'

export const reset = css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  * {
    margin: 0;
    padding: 0;
  }

  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }

  hr {
    border: none;
    border-top: 0.1rem solid currentColor;
  }
`
